<template>
  <div>
    <div class="header w-100 d-flex flex-column row-gap-4">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
            aria-controls="offcanvasExample">
            <i class="fa-solid fa-bars"></i>
          </button>
        </div>
        <div id="div_logo" class="text-end">
          <nuxt-link :to="appLinkHome" :title="appStore.currentEtablissement.siteName">
            <img class="navbar_logo1" src="/img/logos/logo-ferron.png" placeholder="/img/logos/logo-ferron.png" />
          </nuxt-link>
        </div>
      </div>
      <div class="search-container">
        <i class="fas fa-search search-icon"></i>
        <input type="text" class="search-input w-100" placeholder="OEM / Référence ...">
        <i id="searchXmark" class="fa-solid fa-xmark"></i>
      </div>
    </div>
    <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div class="offcanvas-header">
        <!--          <h5 class="offcanvas-title" id="offcanvasExampleLabel">Offcanvas</h5>-->
        <div>
          <nuxt-link :to="appLinkHome" :title="appStore.currentEtablissement.siteName">
            <img class="navbar_logo2" src="/img/logos/logo-ferron.png" placeholder="/img/logos/logo-ferron.png" />
          </nuxt-link>
        </div>
        <div class="d-flex column-gap-3 mx-3">
          <NuxtLink to="/panier">
            <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.73596 14.0186C8.91171 13.699 9.24748 13.5005 9.61218 13.5005H16.4709C17.2209 13.5005 17.8809 13.0905 18.2209 12.4705L21.6017 6.3309C21.7115 6.13146 21.7457 5.91074 21.7138 5.7018C21.8913 5.52131 22.0009 5.2737 22.0009 5.00049C22.0009 4.44821 21.5532 4.00049 21.0009 4.00049H6.00086C5.96789 4.00049 5.93529 4.00209 5.90314 4.0052L5.73256 3.64484C5.40181 2.94606 4.69794 2.50049 3.92484 2.50049H2.9209C2.36862 2.50049 1.9209 2.94821 1.9209 3.50049C1.9209 4.05277 2.36862 4.50049 2.9209 4.50049H3.14604C3.61926 4.50049 4.05017 4.77303 4.25297 5.2006L7.08108 11.1632C7.35718 11.7453 7.33595 12.4248 7.02404 12.9885L6.1709 14.5305C5.4409 15.8705 6.4009 17.5005 7.9209 17.5005H18.9209C19.4732 17.5005 19.9209 17.0528 19.9209 16.5005C19.9209 15.9482 19.4732 15.5005 18.9209 15.5005H9.61217C8.85157 15.5005 8.36941 14.685 8.73596 14.0186ZM17.0417 10.4682L19.5117 6.00049H6.84757L8.90925 10.3562C9.24 11.0549 9.94387 11.5005 10.717 11.5005H15.2914C16.0192 11.5005 16.6895 11.1051 17.0417 10.4682Z"
                fill="#3B393D" />
              <path
                d="M7.92066 18.5005C6.82066 18.5005 5.93066 19.4005 5.93066 20.5005C5.93066 21.6005 6.82066 22.5005 7.92066 22.5005C9.02066 22.5005 9.92066 21.6005 9.92066 20.5005C9.92066 19.4005 9.02066 18.5005 7.92066 18.5005Z"
                fill="#3B393D" />
              <path
                d="M17.9207 18.5005C16.8207 18.5005 15.9307 19.4005 15.9307 20.5005C15.9307 21.6005 16.8207 22.5005 17.9207 22.5005C19.0207 22.5005 19.9207 21.6005 19.9207 20.5005C19.9207 19.4005 19.0207 18.5005 17.9207 18.5005Z"
                fill="#3B393D" />
            </svg>
          </NuxtLink>
          <a href="/">
            <svg width="25" height="25" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 0C8.28877 0 7.71416 0.558594 7.71416 1.25V1.94922C4.80092 2.39844 2.57079 4.85156 2.57079 7.8125V9.11719C2.57079 10.8906 1.94796 12.6133 0.81079 13.9961L0.212069 14.7266C-0.0209898 15.0078 -0.0651907 15.3945 0.0955397 15.7188C0.25627 16.043 0.593804 16.25 0.963483 16.25H17.0365C17.4062 16.25 17.7437 16.043 17.9045 15.7188C18.0652 15.3945 18.021 15.0078 17.7879 14.7266L17.1892 14C16.052 12.6133 15.4292 10.8906 15.4292 9.11719V7.8125C15.4292 4.85156 13.1991 2.39844 10.2858 1.94922V1.25C10.2858 0.558594 9.71123 0 9 0ZM9 3.75H9.32146C11.6279 3.75 13.5004 5.57031 13.5004 7.8125V9.11719C13.5004 10.9883 14.059 12.8125 15.0957 14.375H2.9043C3.94101 12.8125 4.49955 10.9883 4.49955 9.11719V7.8125C4.49955 5.57031 6.37206 3.75 8.67854 3.75H9ZM11.5717 17.5H9H6.42832C6.42832 18.1641 6.69754 18.8008 7.17973 19.2695C7.66192 19.7383 8.3169 20 9 20C9.6831 20 10.3381 19.7383 10.8203 19.2695C11.3025 18.8008 11.5717 18.1641 11.5717 17.5Z"
                fill="#3B393D" />
            </svg>
          </a>
        </div>
        <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="offcanvas-body">
        <ul class="nav flex-column gap2 mt-2">
          <div v-for="(datas, index) in data" :key="index">
            <!-- Si il comporte des sous menu -->
            <li v-if="datas.subCategories.length > 0" class="accordion">
              <button :id="'collapse_' + datas.idCategory" class="accordion-button" data-bs-toggle="collapse"
                :data-bs-target="'#collapseContent_' + datas.idCategory">
                <img class="img" :src="datas.imageCategory" :alt="datas.nameCategory">
                {{ datas.nameCategory }}
              </button>
              <div :id="'collapseContent_' + datas.idCategory" :class="['collapse', { show: datas.showSubMenu }, 'mt-3']">
                <ul class="list-group">
                  <li v-for="subCategory in datas.subCategories" :key="subCategory.idSubCategory">
                    <NuxtLink :class="{ isDisabled: subCategory.disabled }" :href="subCategory.linkSubCategory"
                      class="list-group-item"><i class="fas fa-chevron-right"></i> {{ subCategory.nameSubCategory
                      }}</NuxtLink>
                  </li>
                </ul>
              </div>
            </li>
            <!-- si il ne comporte pas de sous menu -->
            <li v-else class="categorie">
              <nuxt-link :class="{ isDisabled: datas.disabled, active: route.path === datas.link }" :to="datas.link"
                @click.prevent="handleClick(datas)">
                <img class="img" :src="datas.imageCategory" :alt="datas.nameCategory">
                {{ datas.nameCategory }}
              </nuxt-link>
            </li>
          </div>
        </ul>
      </div>
      <div class="offcanvas-footer">
        <div class="box-icon">
          <NuxtLink to="/my-account"><i class="regular-user">
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 13.0005C7.67392 13.0005 6.40215 13.5273 5.46447 14.465C4.52678 15.4026 4 16.6744 4 18.0005V19.0005C4 19.0005 6 21.0005 12 21.0005C18 21.0005 20 19.0005 20 19.0005V18.0005C20 16.6744 19.4732 15.4026 18.5355 14.465C17.5979 13.5273 16.3261 13.0005 15 13.0005H9Z"
                  stroke="#3B393D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M12 13.0005C14.7614 13.0005 17 10.7619 17 8.00049C17 5.23906 14.7614 3.00049 12 3.00049C9.23858 3.00049 7 5.23906 7 8.00049C7 10.7619 9.23858 13.0005 12 13.0005Z"
                  stroke="#3B393D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </i></NuxtLink>
          <a href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
            <i>
              <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.1095 13.4955V10.5045L19.77 8.84401C19.4479 8.01789 19.0012 7.24595 18.4455 6.55501L16.1805 7.16251L13.59 5.66701L12.9825 3.39901C12.1061 3.26553 11.2144 3.26553 10.338 3.39901L9.7305 5.66701L7.14 7.16251L4.875 6.55501C4.32 7.24501 3.8715 8.01751 3.549 8.84401L5.2095 10.5045V13.4955L3.549 15.156C3.8715 15.9825 4.3185 16.7535 4.875 17.445L7.14 16.8375L9.7305 18.333L10.338 20.601C11.2144 20.7345 12.1061 20.7345 12.9825 20.601L13.59 18.333L16.1805 16.8375L18.4455 17.445C19.0005 16.755 19.449 15.9825 19.77 15.156L18.1095 13.4955ZM19.041 19.4685L16.434 18.7695L15.135 19.5195L14.436 22.1295C13.551 22.3695 12.621 22.5 11.661 22.5C10.6995 22.5 9.768 22.371 8.8845 22.1295L8.184 19.5195L6.885 18.7695L4.2795 19.4685C2.93771 18.1444 1.97754 16.4831 1.5 14.6595L3.4095 12.75V11.25L1.5 9.34051C1.97729 7.51634 2.93747 5.85454 4.2795 4.53001L6.885 5.22901L8.184 4.47901L8.8845 1.86901C9.78891 1.62284 10.7222 1.49874 11.6595 1.50001C12.621 1.50001 13.5525 1.62901 14.436 1.87051L15.135 4.48051L16.434 5.23051L19.041 4.53151C20.361 5.83651 21.336 7.48801 21.8205 9.34051L19.9095 11.25V12.75L21.8205 14.6595C21.343 16.4831 20.3828 18.1444 19.041 19.4685ZM11.661 14.7C12.0156 14.7 12.3667 14.6302 12.6942 14.4945C13.0218 14.3588 13.3195 14.1599 13.5702 13.9092C13.8209 13.6585 14.0198 13.3608 14.1555 13.0333C14.2912 12.7057 14.361 12.3546 14.361 12C14.361 11.6454 14.2912 11.2943 14.1555 10.9668C14.0198 10.6392 13.8209 10.3415 13.5702 10.0908C13.3195 9.8401 13.0218 9.64122 12.6942 9.50554C12.3667 9.36985 12.0156 9.30001 11.661 9.30001C10.9449 9.30001 10.2582 9.58447 9.75181 10.0908C9.24546 10.5972 8.961 11.2839 8.961 12C8.961 12.7161 9.24546 13.4029 9.75181 13.9092C10.2582 14.4155 10.9449 14.7 11.661 14.7ZM11.661 16.5C10.4675 16.5 9.32293 16.0259 8.47902 15.182C7.63511 14.3381 7.161 13.1935 7.161 12C7.161 10.8065 7.63511 9.66194 8.47902 8.81803C9.32293 7.97412 10.4675 7.50001 11.661 7.50001C12.8545 7.50001 13.9991 7.97412 14.843 8.81803C15.6869 9.66194 16.161 10.8065 16.161 12C16.161 13.1935 15.6869 14.3381 14.843 15.182C13.9991 16.0259 12.8545 16.5 11.661 16.5Z"
                  fill="#3B393D" />
              </svg>
            </i>
          </a>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
            <p class="gradient-text text-center ">Mes paramètres</p>
            <hr>
            <a class="dropdown-item" href="#">Mon abonnement</a>
            <a class="dropdown-item" href="#">Mes mécaniciens</a>
            <a class="dropdown-item" href="#">Mes prestations</a>
            <a class="dropdown-item" href="#">Mes taux horaires</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAppStore } from "@/store/appStore.js";

const appStore = useAppStore();
const { appLinkHome, appLinkContact, appLinkAccount } = useAppLink();
const route = useRoute();

const data = appStore.currentEtablissement.navbarApp;

//Empecher la redirection si l'élément contient la class isDisabled
const handleClick = (datas) => {
  if (datas.disabled) {
    // Empêcher l'action de redirection si l'élément a la classe "disabled"
    return;
  }

  // Effectuer l'action de redirection normalement
  // window.location.href = datas.link;
};
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #f8f9fa;
  padding: 20px 15px 0 15px;
  overflow: scroll;
  z-index: 2;
}

i {
  font-size: 1.5rem;
}

button {
  border: none;
  background: none;
}

.offcanvas {
  border-right: none;
}

.search-container {
  position: relative;
}

.search-input {
  padding: 8px 30px 8px 30px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  width: 275px;
  font-family: var(--default-font);

  &:focus {
    outline: none;
  }

  &::placeholder {
    font-size: 16px;
    text-align: center;
  }
}

.search-icon,
#searchXmark {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #727272;
}

.search-icon {
  left: 10px;
  font-size: 16px;
}

#searchXmark {
  right: 30px;
  cursor: pointer;
  font-size: 16px;
}

.navbar_logo1 {
  width: 35%;
}

.navbar_logo2 {
  width: 60%;
}

.accordion-button:focus {
  border: none;
}

.accordion-button {
  padding: 0;
  background-color: transparent;
  box-shadow: none;
}

.accordion-button:not(.collapsed) {
  padding: 0;
  background-color: transparent;
  box-shadow: none;

}

.categorie {
  a {
    text-decoration: none;
    color: rgb(var(--mainText)) !important;
  }
}

img.img {
  margin-right: 0.75rem;
}

.list-group-item {
  border: none;
  background-color: transparent;
  padding-left: 2rem;
}

.gap1 {
  gap: 1rem;
  padding: 0 20px;
}

.gap2 {
  gap: 2rem;
  padding: 0 20px;
}

.gap2 li,
.accordion-button {
  font-weight: 700;
  color: rgb(var(--mainText));
}

.box-icon {
  background: white;
  padding: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box-icon i span {
  font-size: 10px;
}

.box-icon i {
  transition: .7s all;
}

.box-icon i:hover {
  transform: translateY(-5px);
}

.box-icon .fa-user {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.box-icon .fa-user:after {
  content: "Mon compte";
  font-size: 13px;
  text-transform: lowercase;
}

.box-icon a {
  text-decoration: none;
  color: rgb(var(--mainText));
  font-size: 16px;
}

.regular-user::after {
  content: "Mon compte";
  font-size: 1rem;
  font-weight: 500;
  margin-left: 5px;
}

@media screen and (max-width: 425px) {
  .offcanvas {
    width: 100%;
  }

}
</style>